import type React from "react";
import Layout from "../../../../components/site/Layout/Layout";
import FAQItem from "./components/FAQItem";
import { faqItems } from "@/data/faqData";

const FAQPage: React.FC = () => {
	return (
		<Layout>
			<div className="w-full max-w-7xl mx-auto px-4 py-8 md:py-16">
				<h1 className="text-3xl font-bold text-center mb-8">よくある質問</h1>
				<div className="space-y-6">
					{faqItems.map((faq) => (
						<FAQItem key={faq.id} question={faq.title} answer={faq.content} />
					))}
				</div>
			</div>
		</Layout>
	);
};

export default FAQPage;
